import { render, staticRenderFns } from "./createStaff.vue?vue&type=template&id=1420919d"
import script from "./createStaff.vue?vue&type=script&lang=js"
export * from "./createStaff.vue?vue&type=script&lang=js"
import style0 from "./createStaff.vue?vue&type=style&index=0&id=1420919d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports